/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormElementDto } from './FormElementDto';
import {
    FormElementDtoFromJSON,
    FormElementDtoFromJSONTyped,
    FormElementDtoToJSON,
    FormElementDtoToJSONTyped,
} from './FormElementDto';

/**
 * 
 * @export
 * @interface FormElementSubSectionDto
 */
export interface FormElementSubSectionDto {
    /**
     * 
     * @type {string}
     * @memberof FormElementSubSectionDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormElementSubSectionDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSubSectionDto
     */
    subtitle?: string;
    /**
     * 
     * @type {Array<FormElementDto>}
     * @memberof FormElementSubSectionDto
     */
    formElements: Array<FormElementDto>;
    /**
     * 
     * @type {string}
     * @memberof FormElementSubSectionDto
     */
    formElementSectionId?: string | null;
}

/**
 * Check if a given object implements the FormElementSubSectionDto interface.
 */
export function instanceOfFormElementSubSectionDto(value: object): value is FormElementSubSectionDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('formElements' in value) || value['formElements'] === undefined) return false;
    return true;
}

export function FormElementSubSectionDtoFromJSON(json: any): FormElementSubSectionDto {
    return FormElementSubSectionDtoFromJSONTyped(json, false);
}

export function FormElementSubSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormElementSubSectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
        'formElements': ((json['formElements'] as Array<any>).map(FormElementDtoFromJSON)),
        'formElementSectionId': json['formElementSectionId'] == null ? undefined : json['formElementSectionId'],
    };
}

export function FormElementSubSectionDtoToJSON(json: any): FormElementSubSectionDto {
    return FormElementSubSectionDtoToJSONTyped(json, false);
}

export function FormElementSubSectionDtoToJSONTyped(value?: FormElementSubSectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'subtitle': value['subtitle'],
        'formElements': ((value['formElements'] as Array<any>).map(FormElementDtoToJSON)),
        'formElementSectionId': value['formElementSectionId'],
    };
}

